import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';

import Moment from 'moment'
Moment.locale('fr')

import {
  Box,
} from '@material-ui/core';

const GroupCard = ({group}) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        position: "relative",
        width:"calc(50% - 15px)",
        overflow:"hidden",
        boxShadow: "#5a5a5a4a 0 0 10px",
        borderRadius: "5px",
        color: "black",
        textDecoration: "none",
        cursor: "pointer",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background:"white",
      }}
      onClick={() => {
        navigate('/admin/groupe/edit/' + group?.id)
      }}
    >
      <Box style={{
        marginBottom: "20px",
      }}>
        <Box sx={{
          fontSize:"22px",
          color:"text.black",
          fontWeight:"bold",
        }}>
          {group?.name}
        </Box>
        <Box sx={{
          paddingTop: "5px",
          fontSize:"14px",
          color:"text.subTitle",
        }}>
          {group?.code}
        </Box>
      </Box>
      <Box sx={{
        display: "flex",
        flexWrap: "wrap",
      }}>
        <Box sx={{
          fontSize:"18px",
          color:"text.black",
          width:"100%",
          paddingBottom:"5px",
        }}>
          {group?.titrePlan}
        </Box>
        {JSON.parse(group?.plan)?.plan?.map((forma, i) => {
          var opacity = 1
          if (Moment(forma.openDate) > Moment(new Date())) {
            opacity = 3
          }
          return (
            <Box key={i} sx={{opacity:opacity}}>
              <Box sx={{
                fontSize: "10px",
                marginRight: "15px",
              }}>
                {forma?.surname}
              </Box>
            </Box>
          )
        })}
      </Box>
      <Box sx={{
        display:'flex',
        justifyContent:'space-between'
      }}>
        <Box sx={{ fontSize: '12px', fontWeight: 300, marginTop: '15px' }}>
          {group?.nUsers} utilisateurs sur {group?.maxSlot} max
        </Box>
        <Box style={{ fontWeight: 'bold', fontSize: '12px', fontWeight: 300, marginTop: '15px', color:'red' }}>
          {group?.archived === "true" &&
            <>{'Groupe archivé'}</>
          }
        </Box>
      </Box>
    </Box>
  )
};

export default GroupCard;
